import { render, staticRenderFns } from "./SidebarServer.vue?vue&type=template&id=b18af5c8&scoped=true"
import script from "./SidebarServer.vue?vue&type=script&lang=js"
export * from "./SidebarServer.vue?vue&type=script&lang=js"
import style0 from "./SidebarServer.vue?vue&type=style&index=0&id=b18af5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18af5c8",
  null
  
)

export default component.exports